import React, { useState } from "react";
import { MapPin, Images, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "./ui/button";
import { ImageModal } from "./ImageModal";
import { mockData } from "../mock";

export const Portfolio = () => {
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [initialIndex, setInitialIndex] = useState(0);

  const openModal = (images, idx = 0) => {
    setModalImages(images);
    setInitialIndex(idx);
    setModalOpen(true);
  };

  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="tex-plate py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <p className="label-kicker mb-4">Recent Work</p>
            <h2 className="font-display text-4xl md:text-5xl font-bold uppercase tracking-tight text-white leading-none">
              Project
              <span className="text-primary"> Portfolio</span>
            </h2>
          </div>
          <Button
            data-testid="portfolio-view-all-btn"
            variant="outline"
            onClick={() => navigate("/portfolio")}
            className="rounded-none font-bold uppercase tracking-widest border-white/30 bg-transparent text-white hover:bg-white hover:text-background self-start"
          >
            View Full Portfolio
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-px bg-border border border-border">
          {mockData.projects.map((project) => (
            <article
              key={project.id}
              data-testid={`portfolio-card-${project.id}`}
              className="group bg-card flex flex-col"
            >
              <div className="relative h-60 overflow-hidden">
                <img
                  src={project.images[0]}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 cursor-pointer"
                  onClick={() => openModal(project.images, 0)}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-card via-transparent to-transparent pointer-events-none" />
                <div className="absolute top-4 left-4 bg-primary text-background text-xs font-bold uppercase tracking-wider px-3 py-1">
                  {project.type}
                </div>
                <button
                  onClick={() => openModal(project.images, 0)}
                  data-testid={`portfolio-gallery-btn-${project.id}`}
                  className="absolute bottom-4 right-4 flex items-center gap-2 bg-background/80 border border-border text-white text-xs font-semibold uppercase tracking-wider px-3 py-1.5 hover:border-primary hover:text-primary transition-colors"
                >
                  <Images className="h-4 w-4" />
                  {project.images.length}
                </button>
              </div>
              <div className="p-6 flex flex-col flex-1">
                <h3 className="font-display text-xl font-bold uppercase tracking-tight text-white leading-tight mb-3 group-hover:text-primary transition-colors">
                  {project.title}
                </h3>
                <p className="text-sm text-gray-400 leading-relaxed mb-4 line-clamp-4">
                  {project.description}
                </p>
                <div className="mt-auto flex items-center gap-2 text-xs text-muted-foreground uppercase tracking-wider">
                  <MapPin className="h-4 w-4 text-primary" />
                  {project.location}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>

      <ImageModal
        images={modalImages}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        initialIndex={initialIndex}
      />
    </section>
  );
};
